import api from './api';
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const encryptData = (data, key) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
};
// const email = 'nq@godofx.com';
// const password = 'Godo@702';

export const authorization = () => {
    const encryptedData = encryptData({
        email: process.env.REACT_APP_USER,
        password: process.env.REACT_APP_PASSWORD,
    }, SECRET_KEY);
    return api.post('/v1/crm/auth/authLogin', { data: encryptedData });
};

export const authorizationCp = (email, password) => {
    return api.post('/v1/cp/auth/login', {
        email,
        password,
    });
};

export const postClient = (params) => {
    console.log("Post client details ", params);
    return api.post('/v1/crm/customers/registrationForm', params);
};

export const postLead = (params) => {
    console.log("Post Lead details ", params);
    return api.post('/v1/crm/customers/leadRegistration', params);
};

export const updateClient = (id, params, rec) => {
    console.log('id data is ', id, params);
    return api.patch('/v1/crm/customers/registrationUpdate/' + id, params);
};

export const updateLeadInfo = (token) => {
    console.log('token is ', token);
    return api.patch(`/v1/crm/customers/leadUpdate/${token}`);
};

export const postCorprateLeadInfo = (params) => {
    console.log('token is ', params);
    return api.post(`/v1/crm/customers/registrationCorprateForm`, params);
};

export const postDirectorInfo = (params) => {
    console.log('Director is ', params);
    return api.post(`/v1/crm/customers/registrationDirector`, params);
};

export const postBeneficialOwnerInfo = (params) => {
    console.log('beneficialOwner is ', params);
    return api.post(`/v1/crm/customers/registrationBenefictialOwners`, params);
};

export const postauthorizedSignatoryInfo = (params) => {
    console.log('authorizedSignatory is ', params);
    return api.post(`/v1/crm/customers/registrationauthorizedSignatory`, params);
};

export const postCorporateInfoUpdate = (id, params) => {
    console.log('CorporateInfoUpdate is ', params);
    return api.patch(`/v1/crm/customers/corprateInfoUpdate/${id}`, params);
};

export const uploadDocuments = async (params) => {
    console.log('Upload Doc Files', params);
    return api.post('/v1/crm/documents', params,{
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    );
}

export const singleRegistration = async (params) => {
    return api.post('/v1/crm/customers/singleRegistration', params);
}

export const gtnRegistration = async (params) => {
    return api.post('/v1/gtn/account/investorAccount', params);
}

export const emailExist = async (params) => {
    console.log('console.l: ', params);
    return api.get(`/v1/crm/customers/emailExist?${params.type}=${params.value}&isClient=1`);
}

export const emailAndPhoneExist = async (params) => {
    return api.get(`/v1/crm/customers/emailExist?email=${params.email}&phone=${params.phone}&isClient=1`);
}